import React, { ComponentType } from 'react';
import { isEmpty } from 'lodash';
import { TableBody, TableCell, TableRow, TableRowProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import { TableCardRowProps } from '../Table/types';

// below necessary to avoid TS conflict in onClick property declared in TableCardRowComponentProps
const SummaryTableRow = (props: Omit<TableRowProps, 'onClick'> & { onClick?: () => void }) => <TableRow {...props} />;
const StyledSummaryTableCell = styled(TableCell)(() => ({
  verticalAlign: 'top',
}));

const StyledSummaryTableRow = styled(SummaryTableRow)(() => ({
  backgroundColor: grey[200],
}));

export type TableSummaryProps<T extends Record<string, string | number | undefined>> = {
  items: Partial<Record<string, T>>;
  summaryRowComponent: ComponentType<TableCardRowProps<T>>;
  emptySummary: string;
};

const TableSummary = <T extends Record<string, string | number | undefined>>({
  items,
  summaryRowComponent: SummaryRowComponent,
  emptySummary,
}: TableSummaryProps<T>) => {
  return (
    <TableBody>
      {isEmpty(items) && emptySummary && (
        <StyledSummaryTableRow>
          <StyledSummaryTableCell colSpan={20}>{emptySummary}</StyledSummaryTableCell>
        </StyledSummaryTableRow>
      )}
      {Object.keys(items).map(key => {
        const value = items[key];
        return (
          value && (
            <SummaryRowComponent
              key={key}
              item={value}
              cellComponent={StyledSummaryTableCell}
              rowComponent={StyledSummaryTableRow}
            />
          )
        );
      })}
    </TableBody>
  );
};

export { TableSummary };
